import { CMS_API_URL } from '../config/apiBase';

/**
 * Submit the storefront contact form to the backend.
 *
 * @param {string} apiBrandSlug - brand API slug (e.g. 'abcse', 'clsdk')
 * @param {Object} payload      - { name, email, topic, topicLabel, message, company?, captchaToken? }
 * @returns {Promise<Object>}   - { ok: true } on success
 * @throws  {Error}             - with a user-facing message on failure
 */
export async function submitContactForm(apiBrandSlug, payload) {
  const res = await fetch(`${CMS_API_URL}/api/forms/${encodeURIComponent(apiBrandSlug)}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    // Laravel validation → { message, errors: { field: [msg] } }; others → { error }.
    const validationMsg = body.errors ? Object.values(body.errors).flat()[0] : null;
    throw new Error(body.error || validationMsg || body.message || `Request failed (${res.status})`);
  }

  return res.json();
}

export default submitContactForm;
